import * as React from 'react';

import { cornerRadiusM, scale150, scale160, scale170 } from '@xing-com/tokens';

import type { SkeletonFormFieldProps } from '..';

import * as Styled from './skeleton-form-field.styles';

export const SkeletonFormField = React.forwardRef<
  HTMLDivElement,
  SkeletonFormFieldProps
>(({ className, size = 'medium', ...props }, forwardedRef): JSX.Element => {
  const sizes = {
    small: scale150,
    medium: scale160,
    large: scale170,
  };

  return (
    <Styled.FormField
      aria-hidden="true"
      className={className}
      cornerRadius={cornerRadiusM}
      data-xds="SkeletonFormField"
      height={sizes[size]}
      ref={forwardedRef}
      role="presentation"
      {...props}
    />
  );
});

SkeletonFormField.displayName = 'SkeletonFormField';
